import { AfterContentInit, AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AuthService } from '../../core/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/app/core/services/data.service';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { reduce, Subject } from 'rxjs';

declare let Strophe: any;
declare let $msg: any;
declare let $pres: any;
declare let $iq: any;
declare let $: any;


interface DocumentCategory {
  id: string;
  title: string;
  count: number;
  icon: string;
  isActive: boolean;
  documentTypes?: string[]; // For identity category
}

@Component({
    selector: 'app-chats',
    templateUrl: './chats.component.html',
    styleUrls: ['./chats.component.css'],
    standalone: false
})
// export class ChatsComponent {
//   message: string = '';

//   constructor(
//     private auth: AuthService, private router: Router, private toastr: ToastrService,
//   ) { }

//   ngOnInit(){
//     this.getRelationships();
//   }

//   getRelationships() {
//     this.auth.getRelationship().subscribe((res: any) => {
//        console.log('get relations:', res)
//     })
//   }

//   getNotify(id:any) {
//     this.auth.notify_user_list(id).subscribe((res: any) => {
//        console.log('notfyid:', res)
//     })
//   }
// }

export class ChatsComponent implements OnInit {
  selectedUser: any[] = []; // from API
  entityClients: any[] = []; // from API
  clientSearch: string = '';
  hideRuleContent: boolean[] = [];

  activeTab: string = 'personal';
  selectedChatUser: any = null;
  activeClient: any = null;
  activeFirm: any = null;
  selectedContact: any = null;
  message: string = '';
  messages: any[] = []; // your chat history
  panelOpenState: boolean = false;

  selectedCategoryTitle: string = 'personal';
  showNoHealthConnectionsMsg: boolean = false;

  action: any;
  selectedFirmJid: string = '';
  selectedFirm: string = '';
  firmUsersList: any[] = [];
  relid: any;
  searchText: string = '';
  documentCategories: DocumentCategory[] = [
    { id: 'personal', title: 'Personal', count: 0, icon: 'person', isActive: true },
    //{ id: 'health', title: 'Health', count: 0, icon: 'favorite', isActive: false },
    { id: 'legal', title: 'Legal & Finance', count: 0, icon: 'gavel', isActive: false },
    { id: 'finance', title: 'Others', count: 0, icon: 'folder', isActive: false },
  ];
  connectionUser: any[] = [];
  selectedFirmId: string | null = null;
  selectedUserId: any = null;

  domain = environment.xmppDomain
  toJID = ""
  toName = "Select Contact"
  ownerName = ""
  contactList = []
  //messages = []
  contactSelected = false
  USERNAME = "" //prof_ravitejachakkadigicoffercom@devchat.digicoffer.com
  PASSWORD: any;
  ownerJID = localStorage.getItem("jid")
  // URL = "https://" + this.domain + "/http-bind";
  URL = "wss://" + this.domain + ":5443/ws";
  imgurl: any;
  messegeInput: string = '';
  existingData: { bizType: string; guid?: string; name?: string } = { bizType: "" }
  chatUserName: any;
  totalUser:any[]=[];

  // --- Mobile/tablet single-panel switching (layout only; CSS lives in chats.component.css) ---
  // True while the conversation panel replaces the contact list on compact screens.
  // The desktop CSS ignores it, so both panels stay visible there.
  isMobileChatOpen: boolean = false;
  @ViewChild('sidebarEl') sidebarEl?: ElementRef<HTMLElement>;
  @ViewChild('backBtn') backBtn?: ElementRef<HTMLButtonElement>;
  private sidebarScrollTop = 0;
  // Keep in sync with the max-width media query in chats.component.css
  private readonly compactQuery = '(max-width: 1024px)';

  constructor(private auth: AuthService, private router: Router, private toastr: ToastrService, private _Activatedroute: ActivatedRoute) {
    Strophe.ui = this
    // this._Activatedroute.paramMap.subscribe(params => {
    //   // this.realtionshipRequest()
    //   var value = params.get('id')
    //   if (value)
    //     this.action = value
    //   this.loadUsersData()
    // });
  }

  ngOnDestroy(): void {
    //console.log("disconnecting")
    Strophe.ui.conn.disconnect()
  }

  ngOnInit() {
    this.getRelationships();
    
    this.auth.get_image().subscribe((res: any) => {
      if (res.error == false) {
        this.imgurl = res.imageUrl;
      }
    })
    this.ownerName = localStorage.getItem('first_name') + " " + localStorage.getItem('last_name');
    this.PASSWORD = localStorage.getItem("TOKEN")
    this.USERNAME = this.ownerJID + "@" + this.domain
    var connection = new Strophe.Connection(this.URL);
     console.log("Connecting with", this.USERNAME, this.PASSWORD);

    connection.connect(this.USERNAME, this.PASSWORD, this.onConnect.bind(this))
    console.log(this.URL)

    Strophe.ui.conn = connection
    this.scrollToBottom()

  }

  getRelationships() {
    // this.auth.getRelationship().subscribe((res: any) => {
    //   this.connectionUser = res.data.relationships;
    // });

    this.auth.get_relationship_bytag('Personal').subscribe((res: any) => {
      this.selectedUser = res.data.relationships;
      this.connectionUser = res.data.relationships;
      //let totalList = res.data?.relationships || [];
      let totalList = (res.data?.relationships || []).filter((item: any) => item.isaccepted === true);
      this.totalUser = totalList.length; // Get the count
      // console.log('User Count List:', this.totalUser);
    });
  }

  setTab(tab: string) {
    this.activeTab = tab;
  }

  toggle(index: number, client: any) {
    this.messegeInput = '';
    client.isExpand = !client.isExpand;
    this.hideRuleContent[index] = client.isExpand;
    this.activeFirm = client.id;
  }

  selectChatUser(user: any) {
    this.messegeInput = '';
    this.selectedChatUser = user;
    this.activeClient = user.rel_id || user.id;
    this.selectedUser.forEach(u => u.isSelected = false);
    user.isSelected = true;

    this.getNotify(user.id);
  }

  getNotify(id: any) {
    this.auth.notify_user_list(id).subscribe((res: any) => {
      //this.messages = res.messages;
      this.firmUsersList = res.data.users
    });
  }

  // sendMessage() {
  //   if (this.message.trim() !== '') {
  //     this.messages.push({ from: 'me', text: this.message, time: new Date().toLocaleTimeString() });
  //     this.message = '';
  //   }
  // }

  getAvatar(user: any): string {
    return 'https://i.pravatar.cc/40?u=' + user.id;
  }
  private isCompactViewport(): boolean {
    return typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(this.compactQuery).matches;
  }

  // Show the conversation panel on compact screens. Does not touch selectedContact or messages.
  private openChatPanel(): void {
    if (!this.isMobileChatOpen && this.sidebarEl) {
      // display:none on the list resets its scroll offset, so remember it for the way back
      this.sidebarScrollTop = this.sidebarEl.nativeElement.scrollTop;
    }
    this.isMobileChatOpen = true;
  }

  // Back arrow (compact screens): return to the contact list, keeping the active contact and messages.
  closeMobileChat(): void {
    this.isMobileChatOpen = false;
    setTimeout(() => {
      if (this.sidebarEl) {
        this.sidebarEl.nativeElement.scrollTop = this.sidebarScrollTop;
      }
    });
  }

  // On compact screens, tapping the contact that is already active just reopens its conversation
  // (no reload, draft message and loaded history kept). Returns true when handled.
  private reopenIfActive(contact: any): boolean {
    if (!this.isCompactViewport() || this.selectedContact !== contact) {
      return false;
    }
    this.openChatPanel();
    setTimeout(() => this.backBtn?.nativeElement.focus());
    return true;
  }

  onSelectContact(rel: any) {
    if (this.reopenIfActive(rel)) {
      return;
    }
    this.selectedContact = rel;
    this.clientSearch = '';
    this.messegeInput = '';
    //console.log('selcont', this.selectedContact)
    this.chatUsers(rel['guid'], rel['business_name'], true, '', 'Admin', 'consumer')
    this.openChatPanel();
  
    // Set focus on the last added textarea
    setTimeout(() => {
      if (this.isCompactViewport()) {
        // avoid popping the on-screen keyboard as soon as the conversation opens
        this.backBtn?.nativeElement.focus();
        return;
      }
      const textareas = document.querySelectorAll('.form-control.textbox.chatinput');
      const lastTextarea = textareas[textareas.length - 1] as HTMLTextAreaElement;
      if (lastTextarea) {
        lastTextarea.focus();
      }
    });

    // Optionally: load messages, update chat panel, etc.
  }

  //for firm mem.
  onSelectFirm(firmId: string) {
    this.selectedFirmId = firmId;
    this.selectedUserId = null;
  }

  onSelectContactId(user: any, firmId: string) {

    if (this.reopenIfActive(user)) {
      return;
    }
    this.clientSearch = '';
    this.messegeInput = '';
    
    this.selectedContact = user;
    this.selectedUserId = user;
    this.selectedFirmId = firmId;
   
    this.chatUsers(this.selectedFirmJid, user['name'], false, user['id'], this.selectedFirmId, '')
    this.openChatPanel();

    // Set focus on the last added textarea
    setTimeout(() => {
      if (this.isCompactViewport()) {
        this.backBtn?.nativeElement.focus();
        return;
      }
      const textareas = document.querySelectorAll('.form-control.textbox.chatinput');
      const lastTextarea = textareas[textareas.length - 1] as HTMLTextAreaElement;
      if (lastTextarea) {
        lastTextarea.focus();
      }
    });

  }

  onPanelOpened(firmId: string) {
    //console.log('Panel opened for firmId:', firmId);
    this.action = firmId; // currently opened firm id so [expanded] works
  }

  // Method used when expanding a firm to fetch its members
  loadFirmUsers(panelOpenState: boolean, rel?: any): void {
    // console.log('panelOpenState', panelOpenState)
    // console.log('jsutrel', rel)
    this.action = rel;
    this.selectedFirm = rel.business_name;
    this.selectedFirmJid = rel.guid;
    this.auth.notify_user_list(rel.id).subscribe(
      (resp:any) => {
        this.selectedFirm = rel.business_name
        this.selectedFirmJid = resp['data']['uid']
        this.firmUsersList = resp['data']['users']
      }
    )

    this.getNotify(this.action?.id)
    // dummy firm users
    // this.firmUsersList = [
    //   { name: 'John Doe', id: '1' },
    //   { name: 'Jane Smith', id: '2' },
    //   { name: 'Ali Khan', id: '3' }
    // ];
  }

  onCategoryClick(category: DocumentCategory) {
    this.documentCategories.forEach(cat => cat.isActive = false);
    category.isActive = true;
    this.selectedContact = null
    this.isMobileChatOpen = false;

    const selectedTitle = category.title.trim();
    //console.log('tito',selectedTitle)

    this.selectedCategoryTitle = selectedTitle.toLocaleLowerCase();
    localStorage.setItem('selectedCategory', selectedTitle);

    if (selectedTitle === 'Health') {
      // this.selectedUser = [];
      this.showNoHealthConnectionsMsg = true;
      return;
    }

    this.showNoHealthConnectionsMsg = false;

    let apiCategory = selectedTitle;
    if (selectedTitle === 'Legal & Finance') apiCategory = 'Lauditor';
    //if (selectedTitle === 'Health') apiCategory = 'Health';
    if (selectedTitle === 'Others') apiCategory = 'ContentCoffer';

    this.auth.get_relationship_bytag(apiCategory).subscribe((res: any) => {
      if (!res.error) {
        this.selectedUser = res.data.relationships;
        //console.log('cat-selectedUser', this.selectedUser)
        this.connectionUser = res.data.relationships;
        //let totalList = res.data?.relationships || [];
        let totalList = (res.data?.relationships || []).filter((item: any) => item.isaccepted === true);
        this.totalUser = totalList.length; // Get the count
        //console.log('User Count List:', this.totalUser);
      }
    });

    this.loadFirmUsers(this.action);
    // this.onSelectFirm(this.selectedFirmId);
  }

  get filteredUsers() {
    if (!this.searchText.trim()) return this.selectedUser;

    const lower = this.searchText.toLowerCase();
    return this.selectedUser.filter(rel => {
      const name = rel.business_name || rel.name || '';
      return name.toLowerCase().includes(lower);
    });
  }

  StartVideo() {
    let jid = this.ownerJID + "@" + this.domain
    console.log("jid", jid)
    let token = localStorage.getItem('TOKEN')
    let firstName = localStorage.getItem('first_name') || '';
    let lastName = localStorage.getItem('last_name') || '';
    let name = `${firstName} ${lastName}`.trim(); // Trim extra spaces
    const link = `${environment.AVChat}?logintype=ind&token=${token}&jid=${jid}&name=${name}`;
    //window.location.href = link;
    window.open(link);
  }

  loadUsersData() {
    this.auth.service_provider_list().subscribe((res: any) => {
      this.contactList = res['data']['relationships'];
      for (let item of this.contactList) {
        if (this.action == item['id']) {
          this.existingData['bizType'] = item['bizType']
          if (item['biztype'] != 'consumer')
            this.loadFirmUsers(true, item)
          else {
            this.existingData['guid'] = item['guid']
            this.existingData['name'] = item['business_name']
          }
        }
      }
    })
  }

  onConnect(status: any) {
    if (status == Strophe.Status.CONNECTING) {
      console.log('Strophe is connecting.');
    } else if (status == Strophe.Status.CONNFAIL) {
      console.log('Strophe failed to connect.');
    } else if (status == Strophe.Status.DISCONNECTING) {
      console.log('Strophe is disconnecting.');
    } else if (status == Strophe.Status.DISCONNECTED) {
      console.log('Strophe is disconnected.');
    } else if (status == Strophe.Status.CONNECTED) {
      console.log('Strophe is connected.');
      Strophe.ui.toastr.success("Connection Established")
      Strophe.ui.conn.addHandler(Strophe.ui.stanzaHandler, null, "message");
      // Strophe.ui.conn.addHandler(Strophe.ui.onOwnMessage, null, 'iq', 'set', null, null);
      // Strophe.ui.conn.addHandler(Strophe.ui.on_presence, null, 'presence', null, null, null);
      Strophe.ui.conn.send($pres().tree());
      if (Strophe.ui.action != '') {
        if (Strophe.ui.existingData['bizType'] == 'consumer')
          Strophe.ui.chatUsers(Strophe.ui.selectedFirmJid, Strophe.ui.selectedFirm, true, '', 'Admin', Strophe.ui.existingData['bizType'])
        else
          Strophe.ui.chatUsers(Strophe.ui.existingData['guid'], Strophe.ui.existingData['name'], true, '', 'Admin', Strophe.ui.existingData['bizType'])
      }
    }
  }

  stanzaHandler(msg: any) {
    // Strophe.ui.conn.addHandler(Strophe.ui.stanzaHandler, null, "message")
    Strophe.ui.xmlParser(msg)
    // Strophe.ui.conn.addHandler(Strophe.ui.stanzaHandler, null, "message");
    return true
  }

  async xmlParser(msg: any) {
    var timeStamp
    var action = "RECEIVE"
    var from = ""
    var messaageBody = $(msg).find('forwarded')[0]
    var body = ""
    if (messaageBody != undefined) {
      var messaage = $(messaageBody).find('message')[0]
      // //console.log(messaage)
      var to = $(messaage).attr('to')
      from = $(messaage).attr('from')
      timeStamp = $(messaageBody).find('delay').attr("stamp")
      timeStamp = new DatePipe('en-US').transform(timeStamp, 'MMM dd yyyy HH:mm')
      // //console.log(to)
    }
    else {
      var to = $(msg).attr('to')
      from = $(msg).attr('from')
      timeStamp = new DatePipe('en-US').transform(new Date(), 'MMM dd yyyy HH:mm')
    }

    if (from.indexOf("/") != -1)
      from = from.split("/")[0]

    var bodies = $(msg).find('body')
    body = Strophe.xmlunescape(Strophe.getText(bodies[0]))
    if (to == (this.toJID + "@" + this.domain))
      action = "SENT"
    else if (from != (this.toJID + "@" + this.domain))
      action = "NONE"
    if (action != "NONE")
      Strophe.ui.messages.push({ text: body, action: action, timestamp: timeStamp })
    this.scrollToBottom()
  }

  scrollToBottom(): void {
    // try {
    //   if (this.myScrollContainer)
    //     this.myScrollContainer.nativeElement.scroll({
    //       top: this.myScrollContainer.nativeElement.scrollHeight,
    //       left: 0,
    //       behavior: 'smooth'
    //     })
    // } catch (err) { }
  }

  ngAfterViewInit() {
    this.scrollToBottom()
  }

  ngAfterViewChecked() {
    // $('.t').last().addClass('active-li').focus();
  }

  restoreMessages() {
    this.messages = []

    var query = $iq({ type: 'set', id: this.toJID })
      .c('query', { xmlns: 'urn:xmpp:mam:2' })
      .c('x', { xmlns: 'jabber:x:data', type: 'submit' })
      .c('field', { var: 'FORM_TYPE', type: 'hidden' })
      .c('value', {}).t('urn:xmpp:mam:2').up().up()
      .c('field', { var: 'with' })
      .c('value', {}).t(`${this.toJID}@${this.domain}`).up().up().up()
      .c('set', { xmlns: 'http://jabber.org/protocol/rsm' })
      .c('max', {}).t('500').up()
      .c('before')
    Strophe.ui.conn.send(query)

  }

  selectUser(value:any) {
    this.toName = value
    this.toJID = 'prof_rajendrasaidigicoffercom'
    this.messages = []
    this.contactSelected = true
    this.restoreMessages()
  }

  sendMessage(message:any) {
    if (message.trim() == "")
      return
    else if (!this.contactSelected) {
      this.toastr.error("Select contact")
      return
    }
    var UserName = localStorage.getItem('first_name')+" "+localStorage.getItem('last_name')
    var subject = UserName + " ##" + this.ownerJID + "## #N#" + UserName + "#N#"
    var msgXML = $msg({ to: `${Strophe.ui.toJID}@${Strophe.ui.domain}`, type: "chat" }).c('subject').t(subject);
    msgXML.up().c('body').t(message);
    Strophe.ui.conn.send(msgXML);
    var timeStamp = new DatePipe('en-US').transform(new Date(), 'MMM dd yyyy HH:mm')
    Strophe.ui.messages.push({ text: message, action: 'SENT', timestamp: timeStamp })
    $("#messege_input").val("")
    this.messegeInput = '';
    this.clientSearch = '';
  }

  getTMFilterValue(value:any) {
    return value.toLowerCase()
  }
    
  chatUsers(jid: string, name: string, isAdmin: any, userid: string, firm: string, biztype: string) {
    // (<HTMLInputElement>document.getElementById("btn_send")).disabled = false;
    this.toJID = jid
    if (!isAdmin)
      this.toJID += "_" + userid
    if (firm == 'Admin') {
      if (biztype == 'consumer')
        this.toName = name
      else
        this.toName = name + " - " + firm
    }
    else
      this.toName = firm + " - " + name
    this.messages = []
    this.contactSelected = true
    // //console.log(this.toJID)
    // const root: XmlElement = $build('presence', {
    //   // from: this.USERNAME, 
    //   from: this.USERNAME,
    //   to: this.toJID+"@"+this.domain,
    //   type: 'probe'
    // });
    this.restoreMessages()
  }

  getFilterValue(item:any) {
    var name = item.business_name
    return name.toLowerCase()
  }
    
  restricttextSpace(event: any) {
    let inputValue: string = event.target.value;
    inputValue = inputValue.replace(/^\s+/, '');
    inputValue = inputValue.replace(/\s{2,}/g, ' ');
    event.target.value = inputValue;
    return;
  }
    
  isMessageEmpty(): boolean {
    return !this.messegeInput.trim();
  }
    
  onKeyDown(event: KeyboardEvent) {
    // Block space at the first position
    if (
      event.key === ' ' &&
      (!this.messegeInput || this.messegeInput.length === 0)
    ) {
      event.preventDefault();
      return;
    }

    // Allow Shift+Enter for newline
    if (event.key === 'Enter' && event.shiftKey) {
      return; // just insert newline
    }

    // Enter without Shift sends message
    if (event.key === 'Enter') {
      event.preventDefault();
      this.sendMessage(this.messegeInput);
    }
  }

}